import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Clevory Academy | Centre de Formation IT en Tunisie ';
const SITE_URL = 'https://clevoryacademy.com';
const DEFAULT_IMAGE = '/assets/images/logo-fond-clair.png';

export default function SEO({
	title = SITE_NAME,
	description = 'Découvrez Clevory Academy, centre de formation IT en Tunisie. Formateurs experts, programmes certifiants et accompagnement vers l’emploi.',
	path = '/',
	image = DEFAULT_IMAGE,
}) {
	const fullTitle = title.includes(SITE_NAME)
		? title
		: `${title} | ${SITE_NAME}`;
	const canonicalUrl = `${SITE_URL}${path}`;

	return (
		<Helmet>
			<title>{fullTitle}</title>

			<meta name='description' content={description} />
			<meta name='robots' content='index, follow' />
			<link rel='canonical' href={canonicalUrl} />

			<meta property='og:title' content={fullTitle} />
			<meta property='og:description' content={description} />
			<meta property='og:type' content='website' />
			<meta property='og:url' content={canonicalUrl} />
			<meta property='og:image' content={`${SITE_URL}${image}`} />

			<meta name='twitter:card' content='summary_large_image' />
			<meta name='twitter:title' content={fullTitle} />
			<meta name='twitter:description' content={description} />
			<meta name='twitter:image' content={`${SITE_URL}${image}`} />
		</Helmet>
	);
}
